module.exports = __webpack_public_path__ + "img/active_white_arrow_right.789747a7.svg";